"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateMixPreviewResponseToJSON = exports.GenerateMixPreviewResponseFromJSONTyped = exports.GenerateMixPreviewResponseFromJSON = exports.instanceOfGenerateMixPreviewResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GenerateMixPreviewResponse interface.
 */
function instanceOfGenerateMixPreviewResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGenerateMixPreviewResponse = instanceOfGenerateMixPreviewResponse;
function GenerateMixPreviewResponseFromJSON(json) {
    return GenerateMixPreviewResponseFromJSONTyped(json, false);
}
exports.GenerateMixPreviewResponseFromJSON = GenerateMixPreviewResponseFromJSON;
function GenerateMixPreviewResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mixPreviewId': !(0, runtime_1.exists)(json, 'mix_preview_id') ? undefined : json['mix_preview_id'],
        'mixPreviewUrl': !(0, runtime_1.exists)(json, 'mix_preview_url') ? undefined : json['mix_preview_url'],
    };
}
exports.GenerateMixPreviewResponseFromJSONTyped = GenerateMixPreviewResponseFromJSONTyped;
function GenerateMixPreviewResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mix_preview_id': value.mixPreviewId,
        'mix_preview_url': value.mixPreviewUrl,
    };
}
exports.GenerateMixPreviewResponseToJSON = GenerateMixPreviewResponseToJSON;
